














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Pinterest extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: '#92A2B0' }) readonly fill?: string;
}
